import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { ExportSidepanel } from 'modules/universal_exports/components/ExportSidepanel'

const SaleInvoicesExporterSidePanel = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const backUrl = navigation.finance.sales.salesInvoices.fullPath()

  return (
    <ExportSidepanel
      resource="finance.financial_document"
      overrideFilters={{ operation_type: ['sale'] }}
      onClose={() => navigate(backUrl)}
    />
  )
}

export default SaleInvoicesExporterSidePanel
